export default __webpack_public_path__ + "static/books-wagon-c251e4b540b84f9d762a807517334722.png";